<template>
    <div class="">
        <!-- <enable-2fa-modal ref="enableModal" v-if="!enabled" />
        <disable-2fa-modal ref="disableModal" v-else /> -->
        <enable-2fa-modal v-if="!enabled" />
        <disable-2fa-modal v-else />
    </div>
</template>  
<script src="./index.js"></script>